import axios from 'axios';

const api = process.env.REACT_APP_API_URL;

const post = (endpoint, data) =>
  axios.post(`${api}${endpoint}`, data, {
    headers: { 'Content-Type': 'application/json' },
  }).then(r => r.data);

const get = (endpoint) =>
  axios.get(`${api}${endpoint}`).then(r => r.data);

export const fetchCheckinConfig = (token) => get(`public/config/${token}`);

export const submitCheckin = (token, data) => post(`public/check-in/${token}`, data);
